import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-initial',
    templateUrl: './initial.component.html',
    styleUrls: ['./initial.component.css'],
    standalone: false
})
export class InitialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
